import ReactDOM from 'react-dom/client';
import './index.css';
import 'dayjs/locale/ru';
import { Provider } from 'react-redux';
import routes from './routes';

import { store } from './core/helpers/store';
import processManager from './core/helpers/ProcessManager';
import { Helmet, HelmetProvider } from 'react-helmet-async';
import AutoUpdateOnIdle from './components/AutoUpdateOnIdle';

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);

const visibleDomain = 'ecash.kz';
const isHiddenSite = window.location.hostname !== visibleDomain;

if (isHiddenSite) {
    let meta = document.querySelector('meta[name="robots"]');
    if (!meta) {
        meta = document.createElement('meta');
        meta.setAttribute('name', 'robots');
        document.head.appendChild(meta);
    }
    meta.setAttribute('content', 'noindex, nofollow');
}

processManager.restoreTaskModelAfterRefreshingPage(() => {
    root.render(
        <HelmetProvider>
            <div className="App">
                {isHiddenSite && (
                    <Helmet>
                        <meta name="robots" content="noindex, nofollow" />
                    </Helmet>
                )}
                <Provider store={store}>
                    {routes()}
                </Provider>
                <AutoUpdateOnIdle />
            </div>
        </HelmetProvider>
    );
});
